<template>
  <div>
    <Alert v-if="isLightProgram(program)" :type="'info'" :icon="'far fa-circle-info'">
      <p class="text-center text-3xl">
        <b>
          <p>
            Your have a light schedule with less than 12 topics. In some months there will be unavoidable gaps in your schedule.
          </p>
        </b>
      </p>
    </Alert>
  </div>
</template>

<script>
import Alert from "@components/UIComponents/Alert";

export default {
  components: { Alert },
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isLightProgram(program) {
      const programTopics = program.topicList;
      return programTopics.length < 12;
    }
  },
};
</script>

<style lang="scss"></style>
